import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../ui/Button';

const Navbar = () => {
  const { user, logout } = useAuth();

  const getUserTypeLabel = (userType, role) => {
    if (userType === 'ALO_ADMIN') {
      return role === 'SUPER_ADMIN' ? 'Super Admin ALO' : `Admin ALO (${role})`;
    }
    if (userType === 'ENTREPRISE') {
      return `Entreprise (${role})`;
    }
    if (userType === 'EMPLOYE') {
      return 'Employé';
    }
    return 'Utilisateur';
  };

  return (
    <nav className="bg-white border-b border-gray-200 px-4 lg:px-6 py-2.5">
      <div className="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl">
        <div className="flex items-center">
          <span className="self-center text-xl font-semibold whitespace-nowrap text-blue-600">
            ALO ADVANCE
          </span>
        </div>
        
        {user && (
          <div className="flex items-center lg:order-2 space-x-4">
            <span className="text-sm text-gray-700">
              {getUserTypeLabel(user.user_type, user.role)}
            </span>
            <Button 
              variant="outline" 
              size="sm"
              onClick={logout}
            >
              Déconnexion
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;